import { init } from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

// todo: add integration with react-router but routing refactor is needed

// eslint-disable-next-line import/prefer-default-export
export function initSentry() {
  init({
    dsn: process.env.REACT_APP_ENVIRONMENT
      ? 'https://f57496063d6445aaa73eb74547fd48ca@o1211001.ingest.sentry.io/6346950'
      : undefined,
    integrations: [new BrowserTracing()],
    environment: process.env.REACT_APP_ENVIRONMENT,
    tracesSampleRate: 0.001,
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications', // dependecies error
      'ResizeObserver loop limit exceeded', // dependecies error
      'Non-Error promise rejection captured with value: Timeout', // captcha error, don't break anything
      'Network request failed', // Network error, maybe add some handling for this in the app
    ],
  });
}
